import React, { createContext, useContext, useState } from "react";

const TabsContext = createContext();

export const TabsProvider = ({ children }) => {
  const [value, setValue] = useState(0);
  return (
    <TabsContext.Provider value={{ value, setValue }}>
      {children}
    </TabsContext.Provider>
  );
};

export const useTabs = () => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error("useTabs must be used within a TabsProvider");
  }
  return context;
};
